import { Injectable } from "@angular/core"
import Apiresponse = require("../models/api-response");

@Injectable()
export class NotificationService
{
     isInfo: boolean;
     isWarning: boolean;
     isError: boolean;
     isSuccess: boolean;
     message: string;
     data: any;
     isDisplaying: boolean;

    constructor() {
        this.clear();
    }

    displayMessage(type: string, msg: string, data:any = null) {
        this.clear();
        this[type] = true;
        this.message = msg;
        if (this.IsJsonString(data)) {
            this.data = JSON.parse(data);
        }
        this.isDisplaying = true;
    }

    displayInfo(msg: string) {
        this.displayMessage("isInfo", msg);
    }

    displaySuccess(msg: string) {
        this.displayMessage("isSuccess", msg);
    }
    displayWarning(msg: string) {
        this.displayMessage("isWarning", msg);
    }
    displayError(msg: string) {
        this.displayMessage("isError", msg);
    }
    displayErrorWithJsonData(msg: string, data: any) {
        this.displayMessage("isError", msg, data);
    }

    displayApiResponseError(msg: Apiresponse.ApiResponse) {
        var errorMessage = "server error";
        if (msg.data.reasonPhrase) {
            errorMessage = msg.data.reasonPhrase;
        }
        else if (msg.statusCode === "403") {
            errorMessage = "Forbidden";
        }
        else if (msg.statusCode !== 0) {
            errorMessage = msg.data;
        }
        this.displayMessage("isError", errorMessage, msg.data);
    }

    clear() {
        this.isInfo = this.isError = this.isSuccess = this.isWarning = this.isDisplaying = false;
        this.message = "";
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}


/** WEBPACK FOOTER **
 ** ./app/services/notification.service.ts
 **/